import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { currentLang, setLanguage } from 'translations'
import { Button } from 'ui'

const LanguageDropDown: FC = () => {
  const { t } = useTranslation()

  const changeLang = async () => {
    const lang = currentLang()
    const newState = lang === 'en' ? 'fr' : 'en'
    setLanguage(newState)
  }
  return (
    <>
      <Button className="btn-light w-15 ml-auto mb-1" onClick={changeLang}>
        <i className="fas fa-language fa-fw mr-2"></i>
        {t('components.topBar.CHANGE_LANGUAGE')}
      </Button>
    </>
  )
}
export default LanguageDropDown
